@if (isCN) {
  <img src="assets/images/img-new-register-popup-zh.jpg" alt="" />
} @else {
  <img src="assets/images/img-new-register-popup-en.jpg" alt="" />
}

<ion-icon id="close" name="close-outline" (click)="dismiss()" />
